import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const usePagination = (items, itemsPerPage, startPageFrom) => {
  const [currentItemsShown, setCurrentItemsShown] = useState(items);
  const [currentPageIndex, setCurrentPageIndex] = useState(startPageFrom ?? 0);
  const [firstIndex, setFirstIndex] = useState(
    Math.ceil(currentPageIndex * itemsPerPage)
  );

  const totalPages = Math.ceil(items?.length / itemsPerPage);
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  const previous = () => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex((prev) => prev - 1);
    } else setCurrentPageIndex(0);
  };

  const next = () => {
    if (currentPageIndex < totalPages - 1) {
      setCurrentPageIndex((prev) => prev + 1);
    } else setCurrentPageIndex(totalPages - 1);
  };

  useEffect(() => {
    let first_Index = Math.ceil(currentPageIndex * itemsPerPage);
    setFirstIndex(first_Index);
    setCurrentItemsShown(items?.slice(first_Index, first_Index + itemsPerPage));
  }, [items, startPageFrom, currentPageIndex]);

  useEffect(() => {
    setCurrentPageIndex(startPageFrom ?? 0);
  }, [items]);

  return [
    currentItemsShown,
    pages,
    currentPageIndex,
    setCurrentPageIndex,
    next,
    previous,
  ];
};

/**takes you to back link */
export const useGoBack = () => {
  const goTo = useNavigate();

  return () => {
    goTo(-1);
  };
};

/**hook that provides speak functionality */
export const useSpeechSynthesis = () => {
  const [isSpeaking, setisSpeaking] = useState(false);
  const checkSpeakSupported = () => {
    if (window?.speechSynthesis && window?.SpeechSynthesisUtterance)
      return true;
    else return false;
  };

  const speakText = (text) => {
    let utterance = new SpeechSynthesisUtterance(text);
    utterance.onstart = () => {
      setisSpeaking(true);
    };
    utterance.onpause = () => {
      setisSpeaking(false);
    };
    utterance.onend = () => {
      setisSpeaking(false);
    };
    if (speechSynthesis?.speaking) speechSynthesis?.cancel();
    speechSynthesis?.speak(utterance);
  };

  return { isSpeakSupported: checkSpeakSupported(), isSpeaking, speakText };
};


export   const calculateDistanceKm = (pointA,pointB) => {
let [lat1,lon1]=pointA;
let [lat2,lon2]=pointB;

  const R = 6371; // radius of Earth in km
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export  const formatDurationInHoursMinutes = (hours) => {
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  return `${h}h ${m}m`;
};